import { useMutation, useQueryClient } from '@tanstack/react-query'
import { rejectMaintenance } from '../../services'
import { toast } from 'sonner'
import { BankQueryKeys } from '@/modules/bank/keys'

export default function useMutationRejectMaintenance() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			id,
			maintenanceKey,
		}: {
			id: string
			maintenanceKey: string
		}) => rejectMaintenance(id, maintenanceKey),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.Maintenances],
			})
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.MaintenancesAll],
			})
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.PaymentGateways],
			})
			toast.success('ยกเลิกการซ่อมบำรุงสำเร็จ')
		},
	})
}
